import { render, staticRenderFns } from "./DivisaoForm.vue?vue&type=template&id=dbdbeda4&lang=html&"
import script from "./DivisaoForm.vue?vue&type=script&lang=js&"
export * from "./DivisaoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/spa/divisao/DivisaoForm.vue
// module id = 1313
// module chunks = 28